import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { EVENT_CONFIG, formatTs, extractDischargeWatts } from './constants'

const useStyles = makeStyles(() => ({
  dlmEventlogWrapper: {
    padding: '16px 20px',
  },
  dlmEventlogTitle: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#111827',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    margin: '0 0 12px 0',
  },
  dlmEventTableContainer: {
    maxHeight: '200px',
    overflowY: 'auto',
    border: '1px solid #e5e7eb',
    borderRadius: '6px',
  },
  dlmEventTable: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '11px',
    '& thead': {
      position: 'sticky',
      top: 0,
      zIndex: 1,
    },
    '& th': {
      padding: '6px 10px',
      textAlign: 'left',
      fontWeight: 500,
      color: '#6b7280',
      background: '#f9fafb',
      borderBottom: '1px solid #e5e7eb',
      fontSize: '10px',
      textTransform: 'uppercase',
      letterSpacing: '0.4px',
    },
    '& td': {
      padding: '5px 10px',
      color: '#374151',
      borderBottom: '1px solid #f3f4f6',
      verticalAlign: 'middle',
    },
  },
  dlmTdTime: {
    fontVariantNumeric: 'tabular-nums',
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
  dlmTdState: { whiteSpace: 'nowrap' },
  dlmTdWatts: { whiteSpace: 'nowrap' },
  dlmTdReason: {
    maxWidth: '300px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: '#6b7280',
    fontSize: '10px',
  },
  dlmEventBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '3px',
    padding: '2px 8px',
    border: '1px solid',
    borderRadius: '10px',
    fontSize: '10px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
  dlmWattsBadge: {
    display: 'inline-block',
    padding: '1px 6px',
    background: '#ecfdf5',
    color: '#059669',
    border: '1px solid #a7f3d0',
    borderRadius: '4px',
    fontSize: '11px',
    fontWeight: 600,
  },
  dlmRowCommandFailed: {
    '& td': { background: '#fef2f2' },
  },
}))

export default function DlmEventLog({ auditLogs }) {
  const classes = useStyles()

  const events = useMemo(() => {
    if (!auditLogs || auditLogs.length === 0) return []
    return [...auditLogs].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
  }, [auditLogs])

  if (events.length === 0) return null

  return (
    <div className={classes.dlmEventlogWrapper}>
      <h3 className={classes.dlmEventlogTitle}>DLM Event Log</h3>
      <div className={classes.dlmEventTableContainer}>
        <table className={classes.dlmEventTable}>
          <thead>
            <tr>
              <th>Time</th>
              <th>Event</th>
              <th>State</th>
              <th>Discharge</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            {events.map((event, index) => {
              const cfg = EVENT_CONFIG[event.event_type] || EVENT_CONFIG.STATE_TRANSITION
              const watts = extractDischargeWatts(event)
              return (
                <tr
                  key={event.id || index}
                  className={event.event_type === 'COMMAND_FAILED' ? classes.dlmRowCommandFailed : ''}
                >
                  <td className={classes.dlmTdTime}>{formatTs(event.timestamp)}</td>
                  <td>
                    <span
                      className={classes.dlmEventBadge}
                      style={{ background: cfg.color + '18', color: cfg.color, borderColor: cfg.color + '40' }}
                    >
                      {cfg.icon} {cfg.label}
                    </span>
                  </td>
                  <td className={classes.dlmTdState}>
                    {event.from_state} {'\u2192'} {event.to_state}
                  </td>
                  <td className={classes.dlmTdWatts}>
                    {watts != null ? <span className={classes.dlmWattsBadge}>{watts}W</span> : '-'}
                  </td>
                  <td className={classes.dlmTdReason} title={event.reason || ''}>
                    {event.reason ? (event.reason.length > 100 ? event.reason.slice(0, 100) + '...' : event.reason) : '-'}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
